import React from 'react';
import './TermsPage.css';


const TermsOfService: React.FC = () => {
  return (
    <div className="terms-of-service">
      <h1>PokerBuddy Terms of Service</h1>
      <p>Last Updated: [Date, e.g., October 26, 2023]</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using the PokerBuddy application and related services (the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Service.</p>

      <h2>2. Changes to Terms</h2>
      <p>We reserve the right to modify these Terms at any time. We will provide notice of material changes by updating the "Last Updated" date. Your continued use of the Service after changes constitutes your acceptance of the new Terms.</p>

      <h2>3. Privacy Policy</h2>
      <p>Your use of the Service is also governed by our Privacy Policy, which details how we handle your information and is incorporated into these Terms by reference.</p>

      <h2>4. User Accounts</h2>
      <p>4.1. You need an account to access most features. You are responsible for maintaining the confidentiality of your account login information (e.g., through Auth0 and connected social accounts).</p>
      <p>4.2. You agree to provide accurate information and keep it updated.</p>
      <p>4.3. You are solely responsible for all activities under your account.</p>

      <h2>5. License to Use the Service</h2>
      <p>5.1. Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your personal, non-commercial poker study and improvement purposes.</p>

      <h2>6. User Conduct and Fair Use</h2>
      <p>6.1. You agree to use the Service lawfully and ethically, solely for its intended purpose of personal poker skill development.</p>
      <p>6.2. Prohibited activities include, but are not limited to:</p>
      <ul>
        <li><strong>Abuse of Resources:</strong> Making excessive, automated, or otherwise unreasonable requests to our servers or AI analysis engine. This includes scripting interactions or using the Service in a way that could impair performance for others.</li>
        <li><strong>Commercial Use:</strong> Using the Service or its outputs (e.g., AI analysis) for any commercial purpose, resale, or service bureau use without our express written permission.</li>
        <li><strong>Malicious Input:</strong> Submitting corrupted, harmful, or excessively large data (e.g., malformed hand histories) intended to disrupt the Service.</li>
        <li><strong>Reverse Engineering:</strong> Attempting to decompile, reverse engineer, disassemble, or otherwise derive the source code or underlying algorithms of the Service or its AI models.</li>
        <li>Harassing or abusing other users (if community features are added).</li>
        <li>Impersonating others or PokerBuddy staff.</li>
        <li>Distributing malware or attempting unauthorized access.</li>
        <li>Using the Service for any illegal activity.</li>
      </ul>
      <p>6.3. We reserve the right to monitor usage and implement rate limiting or other measures to prevent abuse and ensure fair access for all users.</p>

      <h2>7. Intellectual Property</h2>
      <p>7.1. All content and technology comprising the Service, including text, graphics, logos, software, AI models, and analysis methodologies, are the property of PokerBuddy or its licensors and protected by intellectual property laws.</p>
      <p>7.2. The analysis and feedback provided to you are for your personal use under the license granted in Section 5. You may not copy, modify, distribute, sell, or lease any part of the Service or its underlying technology without our written permission.</p>

      <h2>8. Subscriptions and Premium Features (Future)</h2>
      <p>8.1. We may offer premium features or subscription plans in the future. Any terms related to payments, virtual items, or subscriptions will be presented to you before you commit to a purchase.</p>
      <p>8.2. Unless otherwise stated at the time of purchase, all purchases would be final and non-refundable, except as required by law.</p>

      <h2>9. Termination</h2>
      <p>9.1. We may suspend or terminate your account and access to the Service at our discretion, without notice, for conduct violating these Terms (including the Fair Use policy in Section 6), harmful behaviour, or any other reason.</p>

      <h2>10. Disclaimer of Warranties</h2>
      <p>10.1. The Service is provided "as is" and "as available". We disclaim all warranties, express or implied.</p>
      <p>10.2. We do not guarantee the Service will be uninterrupted, error-free, or that AI analysis will be perfectly accurate or guarantee poker success. The Service is an educational tool.</p>

      <h2>11. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, PokerBuddy shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, data, or goodwill resulting from your use or inability to use the Service.</p>

      <h2>12. Governing Law</h2>
      <p>These Terms shall be governed by the laws of [Your Jurisdiction], without regard to conflict of law provisions.</p>

      <h2>13. Contact Information</h2>
      <p>If you have questions about these Terms, please contact us at: contact@pokerbuddy.io</p>
    </div>
  );
};

export default TermsOfService;